import _ from 'lodash';
import defaultState from 'shared/product_tabs/tab_assembly/data/defaultState';

import { PRICE_SELECTED, QUOTED } from 'shared/data/quoteSteps';

const state = _.cloneDeep(defaultState);

if (Spree.assembly) {
  const { quote, quote_parameters, line_item_id } = Spree.assembly;
  state.quantitiesChanged = true;
  state.lineItemId = line_item_id;
  state.quote = quote;

  if (!quote_parameters.bga) {
    quote_parameters.bga = '0';
  }
  state.parameters = _.assign({}, state.parameters, quote_parameters);

  state.quoteStep =
    _.isNil(state.parameters.row_selected) ||
    _.isNil(state.parameters.column_selected)
      ? QUOTED
      : PRICE_SELECTED;
} else if (Spree.fabrication) {
  // If the project does not include assembly, but includes fabrication take parameters from fabrication
  const { part_number, revision, filename } = Spree.fabrication.quote_parameters;

  // We keep a reference to the fabrication quote, because sometimes the
  // user comes from a viewmate quote and the file is already loaded in the quote
  if (Spree.fabrication.quote) {
    state.fabrication_quote = Spree.fabrication.quote.number;
  }

  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = filename;
} else if (Spree.stencils && Spree.stencils.length > 0) {
  // If the project does not include assembly, but includes stencils take parameters from stencils
  const { parameters: stencilParameters } = Spree.stencils[0];
  let { part_number } = stencilParameters;
  const { revision, filename } = stencilParameters;

  if (part_number.endsWith('-Top Side')) {
    part_number = part_number.replace('-Top Side', '');
  } else if (part_number.endsWith('-Bottom Side')) {
    part_number = part_number.replace('-Bottom Side', '');
  } else if (part_number.endsWith('-Combine Top & Bottom')) {
    part_number = part_number.replace('-Combine Top & Bottom', '');
  }

  if (!state.parameters.part_number) {
    state.parameters.part_number = part_number;
  }

  if (!state.parameters.revision) {
    state.parameters.revision = revision;
  }

  if (!state.parameters.filename) {
    state.parameters.filename = filename;
  }
} else if (Spree.parts) {
  // If the project does not include assembly, but includes parts take parameters from parts
  const { part_number, revision, zip_file } = Spree.parts;
  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = zip_file;
}

if (Spree.assemblyVariants && Spree.assemblyVariants.length > 0) {
  state.currentVariant = Spree.assemblyVariants[0].id;
  state.assemblyVariants = {
    'assembly-us': Spree.assemblyVariants.find(
      (v) => v.slug === 'pcb-assembly-services',
    )?.id,
    'assembly-mx': Spree.assemblyVariants.find(
      (v) => v.slug === 'mexico-pcb-assembly-services',
    )?.id,
  };
}

export default state;
